import React from 'react';
import styled from 'styled-components';

/*

Props:

*/

const StyledDiv = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-content: center;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  padding-left: 20px;
  z-index: 99;
  background: white;
  color: ${props => (props.color) ? props.color : 'red'};
  box-shadow: -7px 11px 78px -24px rgba(0,0,0,0.16);
  /* overflow: hidden; */
  /* height: 73px; */
`;

const ContextualBarSC = ({ style, onClick, children, ...rest }) => (
  <StyledDiv className={'ContextualBarSC'} style = {style} onClick = {onClick} {...rest} >
      { children }
  </StyledDiv>
)

export default ContextualBarSC


// WEBPACK FOOTER //
// ./src/js/components/InteractionComponents/ContextualBarSC.jsx